import { routes } from '@/App/routes';
import { selectRfs } from '@/store/state/rfs/rfs.selectors';
import { selectHasSpotRight, selectProductsRights } from '@/store/state/user/user.selectors';
import { useAppSelector } from '@/store/store';
import { Navigate } from 'react-router';
import { MainLayout } from '../Layout/MainLayout';
import { TradeLoader } from './TradeLoader';
import { AmountAndCurrency, ExecuteButton, SwapButton, TradeDatePicker, TradeErrors, TradeRate, TraderModals } from './components';
import { AlertsLink } from './components/AlertsLink';
import { ProductCheckboxes } from './components/ProductCheckboxes/ProductCheckboxes';
import { TradeInfo } from './components/TradeInfo/TradeInfo';
import './Trader.scss';
import { FormattedMessage } from 'react-intl';
import { AmericanForwardCard } from './components/ProductCheckboxes/AmericanForwardCard';

export function Trader() {
  const canSeeTradeTile = useAppSelector(selectHasSpotRight);

  const { hasForwardRight, hasAmericanForwardRight } = useAppSelector(selectProductsRights);

  const { date: maturityDate, spotDate } = useAppSelector(selectRfs);

  const isMaturityDateAfterSpotDate = maturityDate.getTime() > spotDate.getTime();
  const canSeeCheckboxes = hasForwardRight && hasAmericanForwardRight && isMaturityDateAfterSpotDate;
  const canSeeAmericanForwardCard = !hasForwardRight && hasAmericanForwardRight && isMaturityDateAfterSpotDate;

  if (!canSeeTradeTile) {
    return <Navigate replace to={routes.HOME} />;
  }

  return (
    <MainLayout>
      <TradeLoader>
        <div className="Trader row mt-4" data-e2e="trade-form">
          <div className="form col-lg-10">
            <div className="d-lg-none">
              <TradeInfo displayMode="TOP" />
            </div>
            <div className="row">
              <div className="col-md-5">
                <AmountAndCurrency way="buy" />
              </div>
              <div className="col-md-2 d-flex align-items-center justify-content-center">
                <SwapButton />
              </div>
              <div className="col-md-5">
                <AmountAndCurrency way="sell" />
              </div>
            </div>
            <div className="row">
              <div className="form-group date col-md-5">
                <TradeDatePicker />
              </div>
              <TradeRate />
            </div>

            {canSeeCheckboxes && <ProductCheckboxes />}
            {canSeeAmericanForwardCard && (
              <div className="row">
                <div className="form-group date col-md-5">
                  <div className="mb-8px labeler text-secondary fw-medium">
                    <FormattedMessage id="trader.checkboxes.title" />
                  </div>
                  <AmericanForwardCard />
                </div>
              </div>
            )}

            <div className="d-lg-none ">
              <TradeInfo displayMode="BOTTOM" />
            </div>
            <TradeErrors />
            <ExecuteButton />
            <AlertsLink />
          </div>
          <div className="col-lg-4 ps-xl-5 d-none d-lg-flex">
            <TradeInfo displayMode="RIGHT" />
          </div>
          <TraderModals />
        </div>
      </TradeLoader>
    </MainLayout>
  );
}
